import { render, staticRenderFns } from "./PermissionDeniedPage.vue?vue&type=template&id=4c917d28&"
import script from "./PermissionDeniedPage.vue?vue&type=script&lang=js&"
export * from "./PermissionDeniedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports